var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3201 12.7998H18.0795C17.3726 12.7998 16.7997 13.3727 16.7997 14.0803V33.9196C16.7997 34.6271 17.3726 35.2 18.0795 35.2H20.3201C21.0265 35.2 21.5994 34.6271 21.5994 33.9196V14.0803C21.5994 13.3727 21.0265 12.7998 20.3201 12.7998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9206 12.7998H27.68C26.9737 12.7998 26.4008 13.3727 26.4008 14.0803V33.9196C26.4008 34.6271 26.9737 35.2 27.68 35.2H29.9206C30.6276 35.2 31.2005 34.6271 31.2005 33.9196V14.0803C31.2005 13.3727 30.6276 12.7998 29.9206 12.7998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 45.5999C12.0709 45.5999 2.39955 35.9291 2.39955 23.9997C2.39955 12.0709 12.0703 2.39955 23.9997 2.39955C35.9291 2.39955 45.5998 12.0703 45.5998 23.9997C45.5998 35.9291 35.9291 45.5999 23.9997 45.5999ZM23.9997 0C10.7451 0 0 10.7451 0 23.9997C0 37.2549 10.7451 48 23.9997 48C37.2549 48 48 37.2549 48 23.9997C48 10.7451 37.2549 0 23.9997 0Z",
    fill: "#F87E03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.880ed9225dd8f54d5c663d6c51c9e5a4.svg";
export { ForwardRef as ReactComponent };